import FaveStat from './FaveStat';
import container from './FaveStat.container';
export default container(FaveStat);

//# sourceMappingURL=index.js.map